export default __webpack_public_path__ + "static/media/adere.799e2a9a.png";